import { useState } from '#app'

export interface ProductQuickViewRequest {
  itemData: Record<string, any>
  productLink: string
  productTitle: string
}

interface ProductQuickViewState {
  initialized: boolean
  visible: boolean
  requestId: number
  request: ProductQuickViewRequest | null
}

const PRODUCT_QUICK_VIEW_STATE_KEY = 'global-product-quick-view'

export function useProductQuickView() {
  const state = useState<ProductQuickViewState>(PRODUCT_QUICK_VIEW_STATE_KEY, () => ({
    initialized: false,
    visible: false,
    requestId: 0,
    request: null,
  }))

  function openProductQuickView(request: ProductQuickViewRequest) {
    state.value = {
      initialized: true,
      visible: true,
      requestId: state.value.requestId + 1,
      request,
    }
  }

  function closeProductQuickView() {
    state.value.visible = false
  }

  return {
    state,
    openProductQuickView,
    closeProductQuickView,
  }
}
